module.exports = __webpack_public_path__ + "static/media/galway-15.e95d4735.jpg";